<template>
  <div class="pa-login-box-forms">
    <div class="header">
      <div class="logo">
        <LoginBoxTitle />
      </div>

      <div class="separator-field">
        <div class="left-side">
          <router-link to="/registration/notice">新規接続申請</router-link>
        </div>
        <div class="center-side">&nbsp;</div>
        <div class="right-side">&nbsp;</div>
      </div>

      <div class="text-description">
        <p>この通信は24区番外地管理局の認定異界駐在所である秋葉原駐在所が管理するHTTPSサーバーを経由して、塔経市帝の24区番外地管理局が管理する異世界通信交換サーバーへAUETPプロトコルにて通信を試みます。塔経市帝から世丹までの通信は魔線接続法第５４２方式にて安定通信が保証されています。</p>
      </div>
    </div>

    <div class="pa-login-carousel">
      <swiper :options="loginSwiperOption" ref="loginBoxCarousel">
        <swiper-slide>
          <LoginWithEmailBox />
        </swiper-slide>
      </swiper>
    </div>

    <div class="cancel-button">
      <a href="javascript:void(0);" v-on:click.prevent="closeLogin">キャンセル</a>
    </div>
  </div>
</template>

<script>
import LoginBoxTitle from '@/components/FrontParts/LoginModal/LoginBox/Images/login-box-title.svg?inlineF'
import LoginWithEmailBox from '@/components/FrontParts/LoginModal/LoginBox/LoginWithEmailBox.vue'

export default {
  components : {
    LoginBoxTitle,
    LoginWithEmailBox
  },
  data  : function(){
    return {
      loginSwiperOption: {
        slidesPerView : 1,
        loop          : false,
        speed         : 800,
        pagination: {
          el        : '.pa-login-box-forms .swiper-pagination',
          clickable : true
        },
        on: {
          init : function(){
          }
        }
      }
    };
  },
  methods : {
    closeLogin(){
      this.$parent.$parent.$parent.$parent.$emit('closeLoginModal');
    }
  },
  computed: {
    loginBoxCarouselSwiperObj() {
      return this.$refs.loginBoxCarousel.swiper
    },
  }
  // mounted : function(){
  //   const vm = this;
  // }
}
</script>
<style lang="scss">
@import "~bulma/sass/utilities/_all";

div.pa-login-box-forms{
  div.header{
    div.logo{
      text-align: center;

      @include until($tablet) {
        padding:1.6rem 0 0;
      }

      @include from('375px'){
        padding-top:1.8rem;
        padding-bottom:.2rem;
      }

      @include from('410px'){
        padding-top:1.8rem;
        padding-bottom:.4rem;
      }

      @include from('500px'){
        padding-top:2.7rem;
        padding-bottom:.7rem;
      }

      @include from('600px'){
        padding-top:3.2rem;
        padding-bottom:1rem;
      }

      @include from('650px'){
        padding-top:38px;
      }

      div.connecting{
        width:100%;
        position: absolute;
        z-index: 14;
        text-align: center;
      }

      div.connected{
        opacity: 0;
        width:100%;
        position: absolute;
        z-index: 15;
        text-align: center;
      }

      svg{
        @include until($tablet) {
          width:8rem;
        }

        @include from($tablet) {
          width: 14rem;
        }

        @include from('410px'){
          width: 10rem;
        }

        @include from('480px'){
          width: 10rem;
        }

        @include from('540px'){
          width: 13rem;
        }

        @include from('650px'){
          width: 12.5rem;
        }

        &.connecting{
          @include until($tablet) {
            width:5rem;
          }
        }
      }
    }

    div.separator-field{
      width:96%;
      margin:0 auto;
      background-color:#C19A67;
      display: flex;
      flex-direction: row;

       > div{
         font-size:.7rem;
         line-height: 1rem;

         a{
           color: #DDCEB3;
         }
       }

      div.left-side{
        width:45%;
        padding-left:.3rem;
      }

      div.center-side{
        width:10%;
        background-color:#BA833F;
      }

      div.right-side{
        width:45%;
      }
    }

    div.text-description{
      width:97%;
      margin:0 auto;
      padding:.4rem .2rem;
      font-size: .8rem;
      text-align: center;
    }
  }

  div.pa-login-carousel{

  }

  div.cancel-button{
    width:95%;
    text-align: right;
    margin:.8rem auto 0;
    padding:0 0 .8rem 0;
    line-height: 1rem;

    a{
      line-height: 1rem;
      font-size: .8rem;
      vertical-align: bottom;
      color:#3A3A3A;
      text-decoration: underline;
      font-weight: bold;
    }
  }
}
</style>
